import { OrganizationEnum } from '../_models/enum/organization-enum';

/**
 * Issuing organizations (VIKINGNO / VIKINGSE / VIKINGDK) where business login,
 * signup request and My Pages business portal are available.
 * Add markets here when NO/SE launch.
 */
export const BUSINESS_PORTAL_ENABLED_ISSUING_ORGANIZATIONS: readonly OrganizationEnum[] = [
  OrganizationEnum.VIKINGDK,
];

export function isBusinessPortalEnabledForIssuingOrganization(
  organizationId: OrganizationEnum | string | null | undefined,
): boolean {
  if (!organizationId) {
    return false;
  }
  return BUSINESS_PORTAL_ENABLED_ISSUING_ORGANIZATIONS.includes(organizationId as OrganizationEnum);
}
